import { API } from "api/API";
import axios from "axios";
import { TIMEOUTBACKENDCONNECTIONREQUEST } from "constants/constants";

const APIInstance = new API();

interface IBackendConnection {
    data: string;
}

export const getBackendConnection = async (): Promise<string | unknown> => {
    try {
        const url = `${APIInstance.api_root}/keepAlive`;
        const response = await axios.get<IBackendConnection>(url, {
            timeout: TIMEOUTBACKENDCONNECTIONREQUEST,
        });
        if (response.data) {
            return response.data;
        }
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
};
